// import { domain } from "./sitesettings";
const secretKey = "adlfjadlkjflkadjflk";
var domain = process.env.REACT_APP_DOMAIN
export default {
  apiUrl: "http://yoursite.com/api/",
};

const siteConfig = {
  siteName: "TGI GATES",
  siteIcon: "ion-flash",
  footerText: "TGI GATES ©2018 Created by Techlet",
};
const PermissionUserManagement = ["administrator", "data_manager"];
const PermissionUserManagementAddEdit = ["administrator"];
const roleConfig = {
  adminstrator: "Administrator",
  data_manager: "Data Manager",
  data_reviewer: "Data Reviewer",
  data_entry: "Data Entry",
  categorizer: "Categorizer",
};
const MasterConstants = {
  ClaimClassification: "CLF",
  Claim: "CLM",
  Retailer: "R",
  Allegrens: "ALG",
  AllegrenClassification: "ACLF",
  Brand: "BRD",
  Manufacturer: "MNF",
  Store: "S", // for stores
};
/*{rkey: 'Fund Manager', rvalue: 'Fund Manager'},
{rkey: 'Technical Assistance', rvalue: 'Technical Assistance'},
{rkey:'Guest', rvalue: 'Guest'}];*/

const roleDataCollectorVal = "Data Collector";
const nip_type_object = {
  112: "Energy",
  3: "Protien",
  4: "Fat",
  8: "Saturated Fat",
  107: "Trans Fat",
  10: "Polyunsaturated",
  9: "Monounsaturated",
  110: "Carbohydrate",
  27: "Sugar",
  26: "Fibre",
  18: "Sodium mg",
  1217: "Sodium g",
  22: "Calcium",
  185: "Folate",
  1210: "Iodine",
  24: "Iron",
  21: "Magnesium",
  16: "Niacin",
  264: "Omega",
  23: "Phosphorous",
  19: "Potassium",
  15: "Riboflavin",
  14: "Thiamin",
  13: "Vitamin A",
  40: "Vitamin B 12",
  189: "Vitamin B 6",
  20: "Vitamin C",
  37: "Vitamin D",
  38: "Vitamin E",
  25: "Zinc",
  1206: "Added Sugar",
  1207: "Beta-Glucan",
  58: "Caffeine",
  29: "Cholesterol",
  1208: "Energy (kcal)",
  1209: "Flavonoids (Antioxidants)",
  193: "Gluten",
  1219: "Isomalt",
  1220: "Lactilol",
  35: "Lactose",
  1221: "Mannitol",
  97: "Omega-3 (Alpha-Linolenic Acid)",
  1205: "Omega-3 (DHA)",
  1201: "Omega-3 (EPA)",
  1211: "Omega-3 (EPA+DHA)",
  265: "Omega-6",
  1212: "Omega-6 (Linoleic Acid)",
  1213: "Omega-9 (Oleic)",
  1214: "Plant Sterols",
  1215: "Polyphenols",
  1216: "Probiotics (bifidobacterium, lactabacillus etc)",
  154: "Salt",
  1223: "Sorbitol",
  1218: "Vitamin B5 (Pantothenic Acid)",
  1222: "Xylitol",
};
const themeConfig = {
  topbar: "themedefault",
  sidebar: "themedefault",
  layout: "themedefault",
  theme: "themedefault",
};

let pageNo = 10;
let cookieExpireTime = 0.01 * 6 * 4; // IN YEARs (.001 approx 1.5 min)
/*const pageConfig = {
  pageNo: 3
};*/
/****** here you can change server url where api runs********/
const jwtConfig = {
  /********** login url *********/
  enabled: true,
  fetchUrl: domain + "login",
  secretKey: "adlfjadlkjflkadjflk",
};

const catEndPoints = {
  enabled: true,
  read: domain + "gct/list",
  findById: domain + "gct",
  updateAttByMgc: domain + "updateAttByMgc",
  updateNutAttByID: domain + "updateNutAttById",
};

const catTreeEndPoints = {
  enabled: true,
  read: domain + "gct/list/tree",
  leafAdd: domain + "gct/leaf/add",
  leafDel: domain + "gct/leaf/delete",
  diabteseList: domain + "diabetes/list",
  TLLList:domain + "tllSwitch/list",
  diabteseAdd: domain + "diabetes/add",
  TLLAdd: domain + "tllSwitch/add",
  download:domain+"diabetes/export",
};
const TLLExportEndPoints = {
  enabled: true,
  download:domain+"tllSwitch/export",
};



const CountryEndPoints = {
  enabled: true,
  add: domain + "country/add",
  list: domain + "country/list",
  findById: domain + "country/findById/",
  update: domain + "country/update",
};
const DataSourceEndPoints = {
  enabled: true,
  add: domain + "source/add",
  list: domain + "source/list",
}
const MasterEndPoints = {
  enabled: true,
  add: domain + "master/add",
  list: domain + "master/list",
  delete : domain + "master/delete"
  // findById: domain + "master/findById/",
  // update: domain + "master/update",
};
const BrandManufacturerEndPoints = {
  enabled: true,
  add: domain + "brand_manufacturer/add",
  list: domain + "brand_manufacturer/list",
  mappingList: domain + "brand_manufacturer_mapping/list",
  delete : domain + "brand_manufacturer_mapping/delete",
  autoSuggestion: domain + "brand_manufacturer/autoSugg",
  brdMnfExport: domain + "brand_manufacturer/export"
}
const UserEndPoints = {
  enabled: true,
  add: domain + "signup",
  list: domain + "userlist",
};
const RoleEndPoints = {
  enabled: true,
  list: domain + "role/list",
};
const grpSwitchEndPoints = {
  enabled: true,
  findById: domain + "groupSwitch",
  editById: domain + "switchCat",
  editSetMsg: domain + "updateSetMsg",
  grpSwitchAdd: domain + "groupSwitch/add",
};

const catExportEndPoints = {
  enabled: true,
  download: domain + "export/category",
  bulk_Operation: domain + "gct/leaf/bulk_opration"
};
const productExportEndPoints = {
  enabled: true,
  download: domain + "export/products",
  upload: domain + "prod/upload",
};
const dataExtract = {
  enabled: true,
  map: domain + "export/app_data",
  upload: domain + "export/upload",
  download: domain+'export/map_download',
  list: domain+'export/app_data_list'
}

const grpSwitchExportEndPoints = {
  enabled: true,
  download: domain + "export/groupSwitch",
};

const catSwitchExportEndPoints = {
  enabled: true,
  download: domain + "export/catSwitch",
};

const labelEndPoints = {
  enabled: true,
  read: domain + "labels/catlabels",
  findById: domain + "labels/catlabels/details",
};

const groupEndPoints = {
  enabled: true,
  read: domain + "labels/labelgroups",
  findById: domain + "labels/labelgroups/details",
};

const categoriesEndPoints = {
  enabled: true,
  read: domain + "labels/category",
  findById: domain + "labels/category/details",
  editById: domain + "labels/editMapping",
};

const producEndPoints = {
  enabled: true,
  read: domain + "product/list",
  findById: domain + "product/details",
};
const logProducEndPoints = {
  enabled: true,
  read: domain + "log_product/list",
  findById: domain + "log_product/detail",
  discard: domain + "log_product/discard",
  import: domain + "prod/save",
};

const catLabelsExportEndPoints = {
  enabled: true,
  download: domain + "export/catLabelMapping",
};

/**LOGS */
const LogsEndPoint = {
  enabled: true,
  list: domain + "logsList",
  export: domain + "logsExport",
};

const isLeafOptions = {
  true: 1,
  false: 0,
};

const isErrorOptions = {
  true: "Yes",
  false: "No",
};

const isConOptions = {
  true: 1,
  false: 0,
};

const levelOptions = {
  0: "Level 0",
  1: "Level 1",
  2: "Level 2",
  3: "Level 3",
  4: "Level 4",
  5: "Level 5",
};
const withUOMOrder = {
  energy: 0,
  fat: 1,
  satFat: 2,
  sugar: 3,
  fibre: 4,
  sodium: 5,
  serveUnit: 6,
};
var npSystem = {
  npCat: "Nutrient Profile Category",
  hsCat: "Health Star Category",
  hsCatStand: "Health Star Category Standard",
  hsCalCat: "Health Star Calibration Category",
  ovrHsr: "Override Hsr",
  hsrOvrLog: "Hsr Override Logic",
  ovrHsrVal: "Override Hsr Value",
};

var npSystemConfigLabel = {
//  vPoints: "V Points",
  conFvnl: "Concentrated Fvnl",
  fvnl: "Fvnl",
  portSize: "Portion Size",
  isDrink: "Is Drink",
  // carbonDioxide: "CO2e/kg",
  carbonDioxide: "GHGe", // For PC646
  calulatedFvnl: "Fvnl Calculated",
  fvnl_c1: "Fvnl-C1%",
  vpoints_c1: "Vpoints-C1",
  singleIngCategory: "Single Ingredient Category"

};
var npSystemConfigLabelGlobal = {
  vPoints: "V Points",
  conFvnl: "Concentrated Fvnl",
  fvnl: "Fvnl",
  portSize: "Portion Size",
  isDrink: "Is Drink",
  // carbonDioxide: "CO2e/kg",
  carbonDioxide: "GHGe", // For PC646
  calulatedFvnl: "Fvnl Calculated",
  fvnl_c1: "Fvnl-C1%",
  vpoints_c1: "Vpoints-C1",
  singleIngCategory: "Single Ingredient Category"
};
var npSystemnpxWithUom = {
  fibre: "Fibre",
  energy: "Energy",
  fat: "Total Fat",
  satFat: "Saturated Fat ",
  sugar: "Total Sugars",
  sodium: "Sodium",
  serveUnit: "Serving Unit",
};
var switchTypes = {
  classic: "Classic",
  salt: "Salt",
  sugar: "Sugar",
  energy: "Energy",
  fat: "Fat",
  gluten: "Gluten",
  diabetes:"Diabetes",
  "good tucker": "Good Tucker",
  "eco switch": "Eco Switch",
};
var hsrOvrLogDetails = {
  0: "No override logic",
  1: "If NIP type =1,4,5,6 or 7 AND Sodium content <100mg/100g",
  3: "If NIP Type=2",
  4: 'If NIP type =3 Keep Health star rating as "77"',
  5: "If NIP type 1,4,5,6 or 7 AND energy content =0kj/100g or 0kcal/100g",
};
var hsCalCatDetails = {
  "Beverages, non-dairy": "Beverages, non-dairy",
  "Core Cereals": "Core Cereals",
  "Core Dairy - beverages": "Core Dairy - beverages",
  "Core Dairy - cheese": "Core Dairy - cheese",
  "Core Dairy - yoghurt, soft cheese": "Core Dairy - yoghurt, soft cheese",
  "Fats, oils": "Fats, oils",
  Fruit: "Fruit",
  "Non-core foods": "Non-core foods",
  Protein: "Protein",
  Vegetables: "Vegetables",
};
var hsCatDetails = {
  1: 1,
  2: 2,
  3: 3,
  "1D": "1D",
  "2D": "2D",
  "3D": "3D",
};

var npCatDetails = {
  1: 1,
  2: 2,
  3: 3,
};
var ovrHsrValDetails = {
  0.5: 0.5,
  1: 1,
  1.5: 1.5,
  2: 2,
  2.5: 2.5,
  3: 3,
  3.5: 3.5,
  4: 4,
  4.5: 4.5,
  5: 5,
  99: 99,
};
var HsCatStandDetails = {
  1: 1,
  2: 2,
  3: 3,
};
var VPointOptionDetails = {
  0: 0,
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
  7: 7,
  8: 8,
};
var catExport = {
  glb: "Global",
  au: "Australia",
};
var language = {
  EN: "English",
  AR: "Arabic",
  CN: "Chienese",
  ES: "Spanish", //17jan23
};
const sourceTypeOption = {
  Photos: "Photos",
  Import: "Import"
}
var uomAttr = {
  fibre_uomval: ["g", "mg"],
  energy_uomval: ["KJ"],
  fat_uomval: ["g", "mg"],
  satFat_uomval: ["g", "mg"],
  sugar_uomval: ["g", "mg"],
  sodium_uomval: ["g", "mg"],
  serveUnit_uomval: ["g", "ml"],
};
var uomAdd = {
  fibre: ["g", "mg"],
  energy: ["KJ"],
  fat: ["g", "mg"],
  satFat: ["g", "mg"],
  sugar: ["g", "mg"],
  sodium: ["g", "mg"],
  serveUnit: ["g", "ml"],
};
const scheduleDownload = {
  enabled: true,
  sqliteDownload: domain + "export/sqlite_db",
  firebaseMove: domain + "firebase/move",
  eco_Move: domain + "eco/move",
  gluten_Move: domain+ "gluten/move",
  firebaseProd: domain + "firebase/prod",
  eco_Prod: domain + "eco/prod",
  gluten_Prod: domain + "gluten/prod",
  firebaseRevert: domain + "firebase/revert",
  eco_Revert: domain + "eco/revert",
  gluten_Revert: domain + "gluten/revert",
  fsList: domain+ 'db_logs/fs_list',
  otherList: domain+ 'db_logs/other_list',
  downloadCsv: domain+"firebase/csv"
}


var exportFilename = {
  exportCat: "categoryExport.csv",
  exportGroupSwitch: "global_group_flags.csv",
  exportSwitch: "categorySwitchOneToManyExport.csv",
  exportSwitchGhge: "global_groups.csv",
  exportSwitchOneToOne: "categorySwitchOneToOneExport.csv",
  exportLabel: "categoryLabelsExport.csv",
  exportProduct: "productExport.csv",
  exportCountry: "country.csv",
  exportCategoryLabel: "categoryLabel.csv",
  exportLabelGroup: "labelGroup.csv",
  exportClaims : "claimsExport.csv",
  exportClaimsClass : "claimClassificationsExport.csv",
  exportAllergens : "allergensExport.csv",
  exportAllergenGroup : "allergenGroupsExport.csv",
  exportRetailers : "retailersExport.csv",
  exportSource : "sourceExport.csv",
  exportBrand : "brandExport.csv",
  exportManufacturer : "manufacturerExport.csv",
  exportDiabetes:"diabetes.csv",
  exportTLL:"Tll.csv",
 
};

var CategoryDetailColumnName = {
  gctName: [1, "Category Name"],
  isLeaf: [3, "Is Leaf"],
  level: [2, "Level"],
  masterGroupCode: [0, "Master Group Code"],
};
var ClassificationDetailColumnName = {
  name: [0, "Name"],
  // slug: [1, "Slug"],
  status: [2, "Status"],
  created: [3, "Created"],
  updated: [4, "Updated"],
};
var UploadCompletecolums = {
  totalParsedProd: [1, "Total Parsed Products"],
  totalProducts: [0, "Total Products In CSV"],
  totalProdError: [3, "Product With Error"],
  totalProdPass: [2, "Validation Passed Products"],
  dupProd: [4, "Duplicate Products In CSV"],
};
var preparedUnitConst = {
  0: "",
  1: "Fluid ounces (fl oz)",
  2: "Gallon",
  3: "ml",
  4: "g",
  5: "Quart",
  6: "Pint",
  7: "Pound",
  8: "Liter",
  9: "Ounces (oz)",
};
var ProductDetailColumnName = {
  gtin: [1, "GTIN"],
  name: [3, "Product Name"],
  brand_name: [2, "Brand Name"],
  // category: [12, "Category"],

  nip_type: [17, "NIP Type"],
  package_size: [4, "Package Size"],
  package_unit: [5, "Package Unit"],
  serving_size: [6, "Serving Size - As Sold"],
  serving_unit: [7, "Serving Unit - As Sold"],
  prepared_serving_size: [8, "Serving Size - As Prepared"],
  prepared_serving_size_unit: [9, "Serving Unit - As Prepared"],
  servings_per_pack: [10, "Serving Per Pack"],
  date_sheet: [18, "Date Sheet"],
  ingridients: [11, "Ingredients"],
  // nips: [17, "Date Sheet"],
  isError: [13, "Is Error"],
  gtinExists: [14, "Duplicate GTIN"],
  // error:[18, "Date Sheet"],
  fileId: [15, "File Id"],
  userId: [16, "User"],
  duplicateProdId: [17, "Duplicate Product Id"],
  is_concentrate: [19, "Is Concentrate"],
  percent_di: [20, "Percent Di"],
  vegetarian: [21, "Vegetarian"],
  serving_info: [22, "Serving Info"],
  gluten_status_label: [23, "Gluten Status Label"],
  addon_brand_other: [24, "Addon Brand Other"],
  addon_prepared_with_water_only: [25, "Addon Prepared With Water Only"],
  addon_alcohol_percent: [26, "Addon Alcohol %"],
  addon_standard_drinks: [27, "Addon Standard Drinks"],
  addon_lot_number_alcohol_only: [28, "Addon Lot Number Alcohol Only"],
  addon_no_hsr_label_on_pack: [29, "Addon No Hsr Label On Pack"],
  addon_presence_hsr: [30, "Addon Presence Hsr"],
  addon_reported_hsr_on_pack: [31, "Addon Reported Hsr On Pack"],
  addon_multiple_hsrs_reported_on_pack: [32, "Addon Multiple Hsrs Reported On Pack"],
  addon_hsr_energy_only_reported_on_pack: [33, "Addon Hsr Energy Only Reported On Pack"],
  addon_presence_low_gi_logo: [34, "Addon Presence Low Gi Logo"],
  addon_low_gi_glycemic_index: [35, "Addon Low Gi Glycemic Index"],
  addon_presence_of_country_of_origin_labelling: [36, "Addon Presence Of Country Of Origin Labelling"],
  addon_type_of_country_of_origin_labelling: [37, "Addon Type Of Country Of Origin Labelling"],
  addon_percentage_stated_on_country_of_origin_label: [38, "Addon Percentage Stated On Country Of Origin Label"],
  addon_no_product_claims_on_pack: [39, "Addon No Product Claims On Pack"],
  addon_other_claims_on_pack: [40, "Addon Other Claims On Pack"],
  group_master_food_group_code: [41, "Master Food Group Code"],
  // group_name: [42, "Group Name"],
  claims_on_pack: [43, "Claims On Pack"],
  claims_on_pack_with_values: [44, "Claims On Pack With Values"],
  product_contains_allergens: [45, "Product Contains Allergens"],
  product_contains_allergens_other: [46, "Product Contains Allergens Other"],
  product_may_contains_allergens: [47, "Product May Contains Allergens"],
  product_may_contains_allergens_other: [48, "Product May Contains Allergens Other"],
};

var ProductDetailModel = {
  gtin: [0, "GTIN"],
  brand_name: [1, "Brand Name"],
  name: [2, "Product Name"],
  nip_type: [3, "NIP Type"],
  package_size: [4, "Package Size"],
  serving_size: [5, "Serving Size - As Sold"],
  servings_per_pack: [7, "Serving Per Pack"],
  ingridients: [8, "Ingredients"],
  prepared_serving_size: [6, "Serving Size - As Prepared"],
  // category: [8, "Category"],
  is_concentrate: [9, "Is Concentrate"],
  percent_di: [10, "Percent Di"],
  vegetarian: [11, "Vegetarian"],
  serving_info: [12, "Serving Info"],
  gluten_status_label: [13, "Gluten Status Label"],
  addon_brand_other: [14, "Addon Brand Other"],
  addon_prepared_with_water_only: [15, "Addon Prepared With Water Only"],
  addon_alcohol_percent: [16, "Addon Alcohol %"],
  addon_standard_drinks: [17, "Addon Standard Drinks"],
  addon_lot_number_alcohol_only: [18, "Addon Lot Number Alcohol Only"],
  addon_no_hsr_label_on_pack: [19, "Addon No Hsr Label On Pack"],
  addon_presence_hsr: [20, "Addon Presence Hsr"],
  addon_reported_hsr_on_pack: [21, "Addon Reported Hsr On Pack"],
  addon_multiple_hsrs_reported_on_pack: [22, "Addon Multiple Hsrs Reported On Pack"],
  addon_hsr_energy_only_reported_on_pack: [23, "Addon Hsr Energy Only Reported On Pack"],
  addon_presence_low_gi_logo: [24, "Addon Presence Low Gi Logo"],
  addon_low_gi_glycemic_index: [25, "Addon Low Gi Glycemic Index"],
  addon_presence_of_country_of_origin_labelling: [26, "Addon Presence Of Country Of Origin Labelling"],
  addon_type_of_country_of_origin_labelling: [27, "Addon Type Of Country Of Origin Labelling"],
  addon_percentage_stated_on_country_of_origin_label: [28, "Addon Percentage Stated On Country Of Origin Label"],
  addon_no_product_claims_on_pack: [29, "Addon No Product Claims On Pack"],
  addon_other_claims_on_pack: [30, "Addon Other Claims On Pack"],
  group_master_food_group_code: [31, "Master Food Group Code"],
  // group_name: [32, "Group Name"],
  claims_on_pack: [33, "Claims On Pack"],
  claims_on_pack_with_values: [34, "Claims On Pack With Values"],
  product_contains_allergens: [35, "Product Contains Allergens"],
  product_contains_allergens_other: [36, "Product Contains Allergens Other"],
  product_may_contains_allergens: [37, "Product May Contains Allergens"],
  product_may_contains_allergens_other: [38, "Product May Contains Allergens Other"],
  // prepared_serving_size_unit: [8, "Serving Size Unit - As Prepared"],
};

var nipColumnDetails = {
  id_nip_type: [0, "Name"],
  value_per_100: [2, "Per 100"],
  value_per_serve: [4, "Per Serve"],
  lt: [1, "Lt 100"],
  lt_serve: [3, "Lt Serve"],
  prepared_100: [6, "Prepared per 100"],
  prepared_lt: [5, "Lt Prepared 100"],
  prepared_serve: [8, "Prepared Serve"],
  prepared_serve_lt: [7, "Lt  Prepared Serve"],
};
const catFvnlArr = ['1', '1D', '2', '2D', '3', '3D']

var oProxyConst = {
  vPointsConst: "vPoints",
  conFvnlConst: "conFvnl",
  fvnlConst: "fvnl",
  calulatedFvnlConst: "calulatedFvnl",
};
const diabteseNutrientFields = {
  energy: "Energy (KJ)",
  netCarbs: "Net Carbs (g/100g)",
  fibre: "Fibre (g/100g)",
  satFat: "Sat Fat (g/100g)",
  sodium: 'Sodium (mg)',
};

const TLLNutrientFields = {
  fat: "Total Fat (g/100g)",
  saturatedFat: "Saturated Fat (g/100g)",
  sugar: "Total Sugar (g/100g)",
  salt: "Salt (g/100g)",
};
const defaultCutoff = {
  "energy" : {
    "1" : '',
    "2" : '',
    "3" : ''
  },
  "netCarbs" : {
    "1" : '',
    "2" : '',
    "3" : ''
  },
  "fibre" : {
    "1" : '',
    "2" : '',
    "3" : ''
  },
  "satFat" : {
    "1" : '',
    "2" : '',
    "3" : ''
  },
  "sodium" : {
    "1" : '',
    "2" : '',
    "3" : ''
  }
}
//Default cutoffs for TLL
const defaultTLLCutoff = {
  "fat" : {
    "1" : '',
    "2" : '',
    "3" : ''
  },
  "saturatedFat" : {
    "1" : '',
    "2" : '',
    "3" : ''
  },
  "sugar" : {
    "1" : '',
    "2" : '',
    "3" : ''
  },
  "salt" : {
    "1" : '',
    "2" : '',
    "3" : ''
  },
 }
 const switchType={
   diabetes:"diabetesSwitch",
   TLL:"tllSwitch"
 }
 
const logComponents = {
  category: "Category",
  switch : "Switch",
  claims: "Claims",
  "claims classification": "Claims Classifications",
  allergens: "Allergens",
  "allergen groups": "Allergen Groups",
  retailers: "Retailers",
  stores: "Stores",
  source: "Source",
  brands: "Brands",
  manufacturers: "Manufacturers",
  country: "Country",
  user: "User",
};
const logActions = {
  add: "Add",
  edit: "Edit",
  del: "Delete",
  login: "Login",
  // logout: "Logout",
};
const environment = {
  dev: "Development",
  uat: "Staging",
  prod: "Production"
}
const BtnText = {
  dev: "Move to Development",
  uat: "Move to Staging",
  prod: "Move to Production",
  revert: "Revert to Previous Version"
}
const environment2 = {
  prod: "Staging"
}
const CountryName= {
  au: "Australia",
  br: "Brazil",
  kw: "Kuwait",
  ng: "Nigeria", 
  gb: "United Kingdom",
  se: "Sweden",
  nz: "New Zealand",
  za: "South Africa"

}
const staticTableConfig = [
  {
    key: "1",
    sno: "FoodSwitch",
    prefix: "app",
    countryCodes: ["au", "br", "se", "ng", "nz", "za", "gb", "kw"],
  },
  {
    key: "2",
    sno: "EcoSwitch",
    prefix: "eco",
    countryCodes: ["au"],
  },
  {
    key: "3",
    sno: "GlutenSwitch",
    prefix: "gluten",
    countryCodes: ["au"],
  },
];
const DeviceType= {
 android:"Android",
 ios:"iOS"
}
const services_Options = ['tll', 'hsr', 'diabetes', 'phr'];
const logsExportFileName = "logs_export.csv"

const appType = {
  fs: "app",
  es: "eco",
  gs: "gluten"
}
const devMgmt = {
  enabled: true,
  get: domain +  "firebase/config_list",
  update: domain + "firebase/config_update",
  fsConfig: domain + "firebase/only_config",
  esConfig: domain + "eco/only_config",
  gsConfig: domain + "gluten/only_config",
}
const deviceType =  {
  and: "android",
  ios: "ios",
}
const envType = {
  dev: "dev",
  prod: "prod",
}
const application = {
  fs: "Foodswitch",
  es: "Ecoswitch",
  gs: "Glutenswitch"
}

export {
  appType,
  devMgmt,
  deviceType,
  envType,
  application,
  siteConfig,
  language,
  themeConfig,
  jwtConfig,
  pageNo,
  cookieExpireTime,
  catEndPoints,
  catTreeEndPoints,
  isLeafOptions,
  isConOptions,
  levelOptions,
  grpSwitchEndPoints,
  npSystem,
  npSystemConfigLabel,
  npSystemnpxWithUom,
  hsrOvrLogDetails,
  catExport,
  catExportEndPoints,
  grpSwitchExportEndPoints,
  groupEndPoints,
  labelEndPoints,
  categoriesEndPoints,
  catSwitchExportEndPoints,
  catLabelsExportEndPoints,
  exportFilename,
  hsCalCatDetails,
  hsCatDetails,
  npCatDetails,
  HsCatStandDetails,
  uomAttr,
  withUOMOrder,
  VPointOptionDetails,
  ovrHsrValDetails,
  CategoryDetailColumnName,
  producEndPoints,
  nip_type_object,
  productExportEndPoints,
  logProducEndPoints,
  isErrorOptions,
  ProductDetailColumnName,
  UploadCompletecolums,
  ProductDetailModel,
  nipColumnDetails,
  CountryEndPoints,
  uomAdd,
  preparedUnitConst,
  switchTypes,
  UserEndPoints,
  MasterEndPoints,
  RoleEndPoints,
  roleConfig,
  PermissionUserManagement,
  PermissionUserManagementAddEdit,
  secretKey,
  ClassificationDetailColumnName,
  MasterConstants,
  catFvnlArr,
  npSystemConfigLabelGlobal,
  oProxyConst,
  DataSourceEndPoints,
  sourceTypeOption,
  BrandManufacturerEndPoints,
  diabteseNutrientFields,
  TLLNutrientFields,
  defaultCutoff,
  defaultTLLCutoff,
  switchType,
  TLLExportEndPoints,
  LogsEndPoint,
  logComponents,
  logActions,
  logsExportFileName, //new
  dataExtract,
  scheduleDownload,
  environment,
  environment2,
  BtnText,
  CountryName,
  DeviceType,
  services_Options,
  staticTableConfig
};
